import React from 'react';

import classNames from 'classnames';

import Button from 'CommonComponents/Button';

import DownloadIcon from 'Assets/icons/download.svg';
import PlusIcon from 'Assets/icons/plus.svg';

/** One pill per report, "+ New report", and Export to file at the end of the bar for those who may download it. */
export default function ReportTabsBar({ reports, activeReportId, onSelect, onCreate, canCreate, canExport, onExport, exporting, exportDisabled }) {
    return (
        <div className="in-nav horizontal tw-flex-wrap tw-gap-y-1.5" role="tablist" aria-label={$t('Cost allocation reports')}>
            {reports.map((report) => {
                const active = report.id === activeReportId;

                return (
                    <button
                        key={report.id}
                        type="button"
                        role="tab"
                        aria-selected={active}
                        onClick={() => onSelect(report.id)}
                        className={classNames('in-nav__item', active ? 'active' : 'inactive')}
                    >
                        {report.title}
                    </button>
                );
            })}
            {canCreate && (
                <button
                    type="button"
                    onClick={onCreate}
                    className="tw-flex tw-h-8 tw-flex-shrink-0 tw-items-center tw-gap-x-1.5 tw-rounded-lg tw-border tw-border-dashed tw-border-blue-50 tw-bg-transparent tw-px-4 tw-text-blue hover:tw-bg-blue-10"
                >
                    <PlusIcon className="tw-h-3.5 tw-w-3.5" aria-hidden="true" />
                    {$t('New report')}
                </button>
            )}
            {canExport && reports.length > 0 && (
                <div className="!tw-ms-auto tw-flex-shrink-0">
                    <Button variant="outline" small onClick={onExport} disabled={exportDisabled || exporting} loading={exporting}>
                        {!exporting && <DownloadIcon className="tw-h-3.5 tw-w-3.5" aria-hidden="true" />}
                        {exporting ? $t('Preparing file…') : $t('Export to file')}
                    </Button>
                </div>
            )}
        </div>
    );
}
